export enum WebhookEvent {
  GuestBooked = 'guest_booked',
  GuestRescheduled = 'guest_rescheduled',
  GuestCancelled = 'guest_cancelled',
  HostRescheduled = 'host_rescheduled',
  HostCancelled = 'host_cancelled',
  GuestBookingRequestCreated = 'guest_booking_request_created',
  HostBookingRequestAccepted = 'host_booking_request_accepted',
  HostBookingRequestDeclined = 'host_booking_request_declined',
}
